import { createSlice } from '@reduxjs/toolkit';
import { OrderAndUpSellSummary } from '../../interface/commonInterface';

const initialState: OrderAndUpSellSummary[] = [
  {
    orderTotal: '',
    subTotal: '',
    shippingCrg: '',
    tax: '',
    currencyCode: '',
    currency_rate: '',
    currencySymbol: '',
    discount: '',
    products: [
      {
        productDetails: '',
        quantity: 0,
        subTitle: '',
        productName: '',
        productPrice: 0,
        currencySymbol: '',
        variantId: '',
      },
    ],
    SalesTaxAmount: '',
  },
];

export const orderDetailsSlice = createSlice({
  name: 'orderDetails',
  initialState,
  reducers: {
    setOrderDetails(_state, action) {
      return action.payload;
    },
  },
});

export const { setOrderDetails } = orderDetailsSlice.actions;

export default orderDetailsSlice.reducer;
